import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class ClientApiService {
  constructor(private REQ: RequestService) {}

  getClientList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.OSMA_CLIENT,
        sub_authority: subAuthorities.CLIENT.LIST,
        operation: operations.LIST,
        data: 'NA',
        format: 'json',
      },
    };
    return this.REQ.get('osma/client', { query: JSON.stringify(qry) });
  }
}
